import './style/index.js';

import _Tree from './Tree';

export type { TreeProps } from './Tree';
export * from './type';

export const Tree = _Tree;
export default Tree;
